/* eslint-disable react/prop-types */
import React from 'react';
import { ClipLoader } from 'react-spinners';
import { LoadingPageWrapper } from "./style";
import { _ab } from "../style";
var LoadingPage = function LoadingPage(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(LoadingPageWrapper, {
    className: className,
    "data-cy": "loading-spinner",
    "data-testid": "loading-page"
  }, /*#__PURE__*/React.createElement(ClipLoader, {
    size: 30,
    color: _ab.hoverBlue
  }), /*#__PURE__*/React.createElement("span", null, "Loading..."));
};
export default LoadingPage;